import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

const appName = "@@issueAdder/"
const resourceTableAppName = "@@resourceTableIssueAdder"

const getIssuesObj = makePieActionObjs("get", "issues")
// would notmally use patch/post/delete, but in this case, it is always a patch, although with different functions
const removeFromIssueObj = makePieActionObjs("remove", "issues")
const addToIssueObj = makePieActionObjs("add", "issues")
const getOtherRelatedToIssueForAddObj = makePieActionObjs("get", "related_to_issue_for_add")
const getOtherRelatedToIssueForRemoveObj = makePieActionObjs("get", "related_to_issue_for_remove")

const removeFromIssuesResourceTableObj = makePieActionObjs("removeFromResourceTable", "issues")

export const getIssues = prependAppName(appName, getIssuesObj.pieDict)
export const removeFromIssue = prependAppName(appName, removeFromIssueObj.pieDict)
export const addToIssue = prependAppName(appName, addToIssueObj.pieDict)
export const getOtherRelatedToIssueForAdd = prependAppName(appName, getOtherRelatedToIssueForAddObj.pieDict)
export const getOtherRelatedToIssueForRemove = prependAppName(appName, getOtherRelatedToIssueForRemoveObj.pieDict)

export const removeFromIssuesResourceTable = prependAppName(resourceTableAppName, removeFromIssuesResourceTableObj.pieDict)

const actionTypes = prependAppName(
    appName,
    {
        ...getIssuesObj.actionTypes,
        ...removeFromIssueObj.actionTypes,
        ...addToIssueObj.actionTypes,
    }
)

export default actionTypes
